import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const Hero = ({ scrollToContact }) => {
  return (
    <div className="container-fluid linear-gradient-bg body-font d-flex align-items-center">
      <div className="container d-flex align-items-center">
        <div className="row w-100">
          <div className="col-md-8 d-flex flex-column justify-content-center">
            <h1 className="fs-one-title black-color anybody-font">
              24/7 AI-Powered Answering Service
            </h1>
            <p className="fs-three-title anybody-font gray-color py-4 text-center text-lg-start">
              Never Miss a Call: Smart AI Answering, Anytime, Anywhere
            </p>
            <div className="d-lg-flex align-items-lg-center">
              <Button
                className="btn-primary-style fs-three fw-bold"
                as={Link}
                to="/signup"
              >
                Get Started for Free
              </Button>
              <Button
                variant="none"
                onClick={scrollToContact}
                className="ms-lg-3 col-lg-4 col-12 mt-lg-0 mt-2 btn-secondary-style justify-content-center purple-color fs-three fw-bold d-flex align-items-center"
              >
                Talk to Sales
              </Button>
            </div>
            <div className="my-3">
              <img className="me-2" src="/assets/laugh-.png" alt="Play" />
              <span className="fs-one anybody-font gray-color">
                30 minutes completely free. No credit card required
              </span>
            </div>
          </div>
          <div className="col-md-4 text-end">
            <img
              src="/assets/girlImg.png"
              alt="Hero"
              className="noura-girl-img"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
